import React, { useContext } from 'react';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

import { useRootUserList } from 'customHooks/userCustomHooks';
import { FeatureContext } from 'components/AccessResolvers/featureContext';

import { LicensesContext } from '../../licensesContext';

import { ShadowDom } from './ShadowDom';
import { UserRow } from './UserRow';
import { EditAssignmentTableHeader } from './EditAssignmentTableHeader';

export const List = () => {
  const {
    rootState: { rootUserListLoading },
  } = useRootUserList();
  const {
    licensesState: { filteredUserList },
  } = useContext(LicensesContext);
  const {
    featureState: { authV3Enabled },
    corpAcctNbr,
  } = useContext(FeatureContext);

  const userList =
    filteredUserList.filter((user) =>
      authV3Enabled
        ? user.profiles.find(
            (prof) => prof.corporateAccountNumber === corpAcctNbr,
          )?.active
        : user.active,
    ) || [];

  const Row = ({ index, style }) => (
    <UserRow key={index} user={userList[index]} style={style} />
  );

  return (
    <>
      <EditAssignmentTableHeader />
      {rootUserListLoading && <ShadowDom />}
      <AutoSizer defaultWidth="100%">
        {({ height, width }) => (
          <FixedSizeList
            height={height}
            width={width}
            className="m-user-list"
            itemCount={userList.length}
            itemSize={71}
          >
            {Row}
          </FixedSizeList>
        )}
      </AutoSizer>
    </>
  );
};
